// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2VnDu","dragIcon":"Choice_dragIcon__3lBzY","left":"Choice_left__onlif","input":"Choice_input__3NQXC"};